import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideBar from '../Components/SideBar';
import MapArea from '../Components/MapArea';
import './Admin_Main.css';
import {API_BASE_URL} from "../config.js";
const Admin_Main = () => {
  const [activeCases, setActiveCases] = useState([]);
  const [usersStats, setUsersStats] = useState([]);
  const [hotspots, setHotspots] = useState([]); 
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const token = localStorage.getItem('access_token'); 
        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        };

        // تم تعديل الرابط الثالث ليطابق المسار الصحيح في الباك إند
        const [casesResponse, usersResponse, hotspotsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/maps/active-cases/`, config),
          axios.get(`${API_BASE_URL}/users/`, config),
          axios.get(`${API_BASE_URL}/geoclusters/active_hotspots/`, config) // الرابط الصحيح
        ]);
        console.log("Hotspots (GeoClusters):", hotspotsResponse.data);
        setActiveCases(casesResponse.data);
        setUsersStats(usersResponse.data);
        setHotspots(hotspotsResponse.data || []); 
      } catch (err) {
        handleApiError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdminData();
  }, []);

  const handleApiError = (err) => {
    if (err.response) {
      const status = err.response.status;
      const data = err.response.data;
      switch (status) {
        case 401: setError("انتهت صلاحية الجلسة أو أنك غير مسجل الدخول."); break;
        case 403: setError("ليس لديك الصلاحيات الكافية."); break;
        case 400: setError(data.detail || "طلب غير صالح."); break;
        case 404: setError("المورد المطلوب غير موجود."); break;
        default: setError("حدث خطأ داخلي في الخادم."); break;
      }
    } else if (err.request) {
      setError("تعذر الاتصال بالخادم. تأكد من تشغيل الباك إند.");
    } else {
      setError(`خطأ غير متوقع: ${err.message}`);
    }
  };

  return (
    <div dir="rtl" className="admin-main-container flex h-screen">
      <SideBar role='admin' usersStats={usersStats} />
      <div className="flex-grow relative overflow-hidden flex flex-col">
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative m-4 shadow-sm z-50" role="alert">
            <strong className="font-bold">تنبيه: </strong>
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        {isLoading ? (
          <div className="flex justify-center items-center h-full bg-[#051320]">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
          </div>
        ) : (
          <MapArea activeCases={activeCases} hotspots={hotspots} />
        )}
      </div>
    </div>
  );
}

export default Admin_Main;